<template>
  <div
    class="c-lens"
    @mouseleave="onMouseleave"
    @mousemove="onMousemove"
    :style="styleContainer"
  >
    <img class="c-lens__image" :src="src" :style="stylePositionImage" />
  </div>
</template>

<script>
const ZOOM_WINDOW_SIZE = 400

export default {
  name: 'ComponentLens',
  props: {
    element: { type: Element, required: true },
    rate: { type: Number, default: 3 },
  },
  data() {
    return {
      src: '',
      styleContainer: {},
      stylePositionImage: {},
    }
  },
  mounted() {
    this.element.style.cursor = 'zoom-in'
    this.src = this.element.getAttribute('src')
    this.element.addEventListener('mousemove', this.zoomImage)
  },
  unmounted() {
    this.element.removeEventListener('mousemove', this.zoomImage)
  },
  methods: {
    zoomImage($event) {
      this.styleContainer = {
        bottom: `${window.innerHeight - $event.pageY + window.scrollY}px`,
        left: `${$event.pageX - window.scrollX}px`,
      }

      const rect = this.element.getBoundingClientRect()
      const relativePositionY = $event.clientY - rect.top
      const ratePositionY = relativePositionY / rect.height
      const relativePositionX = $event.clientX - rect.left
      const ratePositionX = relativePositionX / rect.width

      const width = rect.width * this.rate
      const height = rect.height * this.rate
      this.stylePositionImage = {
        marginTop: `${-1 * width * ratePositionY + ZOOM_WINDOW_SIZE / 2}px`,
        marginLeft: `${-1 * height * ratePositionX + ZOOM_WINDOW_SIZE / 2}px`,
        width: `${width}px`,
        height: `${height}px`,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/variables';

.c-lens {
  background-color: #fff;
  border: 1px solid variables.$color-accent-weak;
  border-radius: 20px;
  overflow: hidden;
  position: fixed;
  width: 400px;
  height: 400px;
  z-index: variables.$z-index-lens;

  &__image {
    max-width: unset;
  }
}
</style>
